module.exports = __webpack_public_path__ + "static/media/Barclays.129adc39.svg";